export const AVAILABLE_MODELS = [
	// Azure OpenAI
	{ key: 'azure.gpt-6.1-sol', name: 'GPT 6.1 Sol', vendor: 'OpenAI' },
	{ key: 'azure.gpt-6-luna', name: 'GPT 6 Luna', vendor: 'OpenAI' },

	// Azure OpenAI EOL
	{ key: 'azure.o3', name: 'o3', vendor: 'OpenAI', eol: true },
	{ key: 'azure.o4-mini', name: 'o4 mini', vendor: 'OpenAI', eol: true },
	{ key: 'azure.gpt-5.4', name: 'GPT 5.4', vendor: 'OpenAI', eol: true },
	{
		key: 'azure.gpt-5-mini',
		name: 'GPT 5 mini',
		vendor: 'OpenAI',
		eol: true
	},
	{
		key: 'azure.gpt-5.4-pro',
		name: 'GPT 5.4 pro',
		vendor: 'OpenAI',
		eol: true
	},
	{ key: 'azure.gpt-5.2', name: 'GPT 5.2', vendor: 'OpenAI', eol: true },
	{ key: 'azure.gpt-5.1', name: 'GPT 5.1', vendor: 'OpenAI', eol: true },
	{ key: 'azure.gpt-5-pro', name: 'GPT 5 pro', vendor: 'OpenAI', eol: true },
	{ key: 'azure.gpt-5', name: 'GPT 5', vendor: 'OpenAI', eol: true },
	{
		key: 'azure.gpt-5-nano',
		name: 'GPT 5 nano',
		vendor: 'OpenAI',
		eol: true
	},
	{ key: 'azure.o3-pro', name: 'o3 pro', vendor: 'OpenAI', eol: true },
	{ key: 'azure.gpt-4.1', name: 'GPT 4.1', vendor: 'OpenAI', eol: true },

	// SCW OpenAI OSS
	{ key: 'gpt-oss-120b', name: 'GPT OSS', vendor: 'OpenAI' },

	// US OpenAI
	{ key: 'o4-mini', name: 'o4 mini', vendor: 'OpenAI (US)', eol: true },
	{ key: 'gpt-5.1', name: 'GPT 5.1', vendor: 'OpenAI (US)', eol: true },
	{ key: 'gpt-5-mini', name: 'GPT 5 mini', vendor: 'OpenAI (US)', eol: true },
	{ key: 'gpt-5-nano', name: 'GPT 5 nano', vendor: 'OpenAI (US)', eol: true },
	{ key: 'gpt-4.1', name: 'GPT 4.1', vendor: 'OpenAI (US)', eol: true },

	// US Anthropic
	{
		key: 'claude-opus-4-6',
		name: 'Claude Opus 4.6',
		vendor: 'Anthropic (US)',
		eol: true
	},
	{
		key: 'claude-sonnet-5',
		name: 'Claude Sonnet 5',
		vendor: 'Anthropic (US)',
		eol: true
	},
	{
		key: 'claude-sonnet-4-6',
		name: 'Claude Sonnet 4.6',
		vendor: 'Anthropic (US)',
		eol: true
	},
	{
		key: 'claude-haiku-4-5',
		name: 'Claude Haiku 4.5',
		vendor: 'Anthropic (US)',
		eol: true
	},

	// Vertex Anthropic
	{
		key: 'vertex.claude-fable-5-1',
		name: 'Claude Fable 5.1',
		vendor: 'Anthropic',
		adminOnly: true
	},
	{
		key: 'vertex.claude-opus-5-5',
		name: 'Claude Opus 5.5',
		vendor: 'Anthropic'
	},
	{
		key: 'vertex.claude-sonnet-5-5',
		name: 'Claude Sonnet 5.5',
		vendor: 'Anthropic'
	},
	{
		key: 'vertex.claude-haiku-5-5',
		name: 'Claude Haiku 5.5',
		vendor: 'Anthropic'
	},

	// Vertex Anthropic EOL
	{
		key: 'vertex.claude-opus-5',
		name: 'Claude Opus 5',
		vendor: 'Anthropic',
		eol: true
	},
	{
		key: 'vertex.claude-sonnet-5',
		name: 'Claude Sonnet 5',
		vendor: 'Anthropic',
		eol: true
	},
	{
		key: 'vertex.claude-sonnet-4-6',
		name: 'Claude Sonnet 4.6',
		vendor: 'Anthropic',
		adminOnly: true,
		eol: true
	},
	{
		key: 'vertex.claude-haiku-4-5@20251001',
		name: 'Claude Haiku 4.5',
		vendor: 'Anthropic',
		adminOnly: true,
		eol: true
	},
	{
		key: 'vertex.claude-fable-5',
		name: 'Claude Fable 5',
		vendor: 'Anthropic',
		adminOnly: true,
		eol: true
	},
	{
		key: 'vertex.claude-opus-4-8',
		name: 'Claude Opus 4.8',
		vendor: 'Anthropic',
		eol: true
	},

	// Bedrock Anthropic EOL
	{
		key: 'eu.anthropic.claude-opus-4-6-v1',
		name: 'Claude Opus 4.6',
		vendor: 'Anthropic',
		eol: true
	},
	{
		key: 'eu.anthropic.claude-sonnet-4-6',
		name: 'Claude Sonnet 4.6',
		vendor: 'Anthropic',
		eol: true
	},
	{
		key: 'eu.anthropic.claude-haiku-4-5-20251001-v1:0',
		name: 'Claude Haiku 4.5',
		vendor: 'Anthropic',
		eol: true
	},

	// Llama
	{ key: 'llama-3.3-70b-instruct', name: 'Llama 3.3', vendor: 'Meta' },

	// Mistral
	{ key: 'mistral-large-4', name: 'Mistral Large 4', vendor: 'Mistral' },
	{
		key: 'mistral-medium-3-5',
		name: 'Mistral Medium 3.5',
		vendor: 'Mistral'
	},
	{ key: 'mistral-small-2603', name: 'Mistral Small 4', vendor: 'Mistral' },

	// Mistral EOL
	{
		key: 'mistral-large-latest',
		name: 'Mistral Large',
		vendor: 'Mistral',
		eol: true
	},
	{
		key: 'mistral-medium-latest',
		name: 'Mistral Medium',
		vendor: 'Mistral',
		eol: true
	},
	{
		key: 'mistral-small-latest',
		name: 'Mistral Small',
		vendor: 'Mistral',
		eol: true
	},
	{
		key: 'magistral-medium-latest',
		name: 'Magistral Medium',
		vendor: 'Mistral',
		eol: true
	},
	{
		key: 'magistral-small-latest',
		name: 'Magistral Small',
		vendor: 'Mistral',
		eol: true
	},

	{ key: 'gemma-3-27b-it', name: 'Gemma 3', vendor: 'Google', eol: true },
	{ key: 'gemma-4-26b-a4b-it', name: 'Gemma 4', vendor: 'Google' },

	{
		key: 'deepseek-v4.1-flash',
		name: 'DeepSeek V4.1 Flash',
		vendor: 'DeepSeek'
	},
	{ key: 'deepseek-v4-flash-0731', name: 'DeepSeek V4 Flash', vendor: 'DeepSeek', eol: true },
	{
		key: 'deepseek-r1-distill-llama-70b',
		name: 'DeepSeek r1 (70b)',
		vendor: 'DeepSeek',
		eol: true
	},

	{ key: 'qwen3-235b-a22b-instruct-2507', name: 'Qwen 3', vendor: 'Alibaba' },
	{ key: 'qwen3.5-397b-a17b', name: 'Qwen 3.5', vendor: 'Alibaba' },
	{ key: 'qwen3.6-35b-a3b', name: 'Qwen 3.6', vendor: 'Alibaba' },
	{ key: 'qwen3.8-27b', name: 'Qwen 3.8', vendor: 'Alibaba' },

	{ key: 'holo2-30b-a3b', name: 'Holo 2', vendor: 'H Company', eol: true },

	{ key: 'glm-5.3', name: 'GLM 5.3', vendor: 'Z.ai' },
	{ key: 'glm-5.2', name: 'GLM 5.2', vendor: 'Z.ai', eol: true }
];

export const DEFAULT_FALLBACK_MODEL = 'vertex.claude-sonnet-5-5';
